/* eslint-disable react/require-optimization */
import React from 'react';

import styles from '@/components/commons/table/Table.module.css';

class LockedCell extends React.Component {
    ref;

    props;

    getSnapshotBeforeUpdate(prevProps) {
        if (!this.ref) {
            return null;
        }

        const { isDragOccurring } = this.props;
        const isDragStarting = isDragOccurring && !prevProps.isDragOccurring;

        if (!isDragStarting) {
            return null;
        }

        const { width, height } = this.ref.getBoundingClientRect();

        return {
            width,
            height,
        };
    }

    componentDidUpdate(_prevProps, _prevState, snapshot) {
        const { ref } = this;
        if (!ref) {
            return;
        }

        if (snapshot) {
            if (ref.style.width === snapshot.width) {
                return;
            }
            ref.style.width = `${snapshot.width}px`;
            ref.style.height = `${snapshot.height}px`;
            return;
        }

        const { isDragOccurring } = this.props;
        if (isDragOccurring) {
            return;
        }

        // inline styles not applied
        if (ref.style.width == null) {
            return;
        }

        // no snapshot and drag is finished - clear the inline styles
        ref.style.removeProperty('height');
        ref.style.removeProperty('width');
    }

    setRef = (ref) => {
        this.ref = ref;
    };

    render() {
        const { children } = this.props;
        return (
            <td
                ref={this.setRef}
                className={styles.bodyCell}
            >
                {children}
            </td>
        );
    }
}

export default LockedCell;
